import React, { useEffect, useState } from "react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Button, ButtonGroup, Col, Input, InputGroup, Row } from "reactstrap";
import CustomDataTable from "../../Components/CustomTable/CustomTable";
import { Triangle } from "react-loader-spinner";
import ItemService from "../../Services/QRCodeServices/MenuItem/ItemService";
import ContactMessageService from "../../Services/QRCodeServices/ContactMessageService/ContactMessageService";
import { Link } from "react-router-dom";
import DeleteModal from "../CRUD/generalAdmin/DeleteModal";
import toast from "react-hot-toast";

const ContactMessage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const [filterText, setFilterText] = useState(""); // Filter text state

  const filteredData = data.filter((item) => {
    const searchText = filterText.toLowerCase();
    return item?.name?.toLowerCase().includes(searchText);
    //   item?.ingredients?.toLowerCase().includes(searchText)
  });

  const fetchData = async () => {
    setLoading(true); // Start loading
    try {
      const response = await ContactMessageService.getList();
      console.log("🚀 ~ fetchData ~ response:", response);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Stop loading after API call is done
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await ContactMessageService.delete(selectedDeleteItem.id);
        setData((prevData) =>
          prevData.filter((item) => item.id !== selectedDeleteItem.id)
        );
        toast.success("Message deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the message");
      } finally {
        toggleDeleteModal();
        setSelectedDeleteItem(null);
        fetchData();
      }
    }
  };
  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDeleteModal();
  };
  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },

    {
      name: "Name",
      selector: (row) => (
        <Link to={`/contact-message/detail/${row?.id}`}>{row?.name}</Link>
      ),
      sortable: true,
    },

    {
      name: "Org Code",
      selector: (row) => row?.orgCode || "N/A",
      sortable: true,
    },

    {
      name: "Email",
      selector: (row) => row?.email || "N/A",
      sortable: true,
    },
    {
      name: "Message",
      selector: (row) => row.message,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <ButtonGroup className="gap-3">
          <Button
            color="danger"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "30px", height: "30px" }}
            onClick={() => handleDeleteClick(row)}
          >
            <i className="bx bx-trash"></i>
          </Button>
        </ButtonGroup>
      ),
      center: true,
    },
  ];
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Contact Message" pageTitle="Message List" />
      </div>
      <Row className="">
        <Col md={5} xs={12} className="px-xs-1 mb-1">
          <InputGroup>
            <Input
              placeholder="Search by title"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
            />
          </InputGroup>
        </Col>
      </Row>

      <CustomDataTable
        responsive
        striped
        pagination
        fixedHeader
        persistTableHead
        progressPending={loading}
        columns={columns}
        data={filteredData}
        customStyles={{
          headCells: {
            style: {
              fontSize: "0.93rem",
              fontWeight: 610,
            },
          },
          rows: {
            style: {
              fontSize: "0.9rem",
            },
          },
        }}
        progressComponent={
          <div className="my-3">
            <Triangle
              visible={true}
              height="80"
              width="80"
              color="#5B71B9"
              ariaLabel="triangle-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
            <h5 className="mt-1">Loading...</h5>
          </div>
        }
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedDeleteItem}
      />
    </div>
  );
};

export default ContactMessage;
